export default "__VITE_ASSET__Bl8iHFWj__"